var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-bar-content"},[_c('a-space',{attrs:{"size":"large"}},[_c('div',{staticClass:"tool-bar-content-item"},[_c('UserToolBar')],1),_c('div',{staticClass:"tool-bar-content-item"},[_c('SettingToolBar')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }